export default __webpack_public_path__ + "static/media/edit.inline.31bf504d.svg";